import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import Tools from './Tools';
import InboundConnections from "./InboundConnections";
import { useLocation } from 'react-router-dom';
import { ReactComponent as UserSvgIcon } from './icons/user.svg';
import './css/UserMenu.css';
import { useSoftphone } from './SoftphoneContext.jsx';

const UserMenu = (props) => {
    const [sessionData, setSessionData] = useState({}); 
    const [visibilityMenu, setVisibilityMenu] = useState(false); 
    const [showPauseMenu, setShowPauseMenu] = useState(false); 
    const [userStatus, setUserStatus] = useState(null); 
    const [visibleinboundConnections, setVisibleInboundConnections] = useState(false); 
    const [error, setError] = useState(false);
    const location = useLocation();
    const { incomingCallStatus, unregister } = useSoftphone();
    let history = useHistory();

    
    

    useEffect(() => {
        
        let sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        // const socket = Tools.currentSocketConnection;
        // socket.on("forceLogout", data => {
        //     logout();
        //     setTimeout(() => alert('Su sesión se encuentra inactiva, se ejecutó un cierre de sesión remoto.'), 2000);
        // });

        // socket.on("userOnCall", data => {
        //     console.log('🟡 DEBUG userOnCall');
        //     //setUserStatus({ paused: true, code: 'RINGING', desc: 'Ringing' });
        //     changeUserStatus({ paused: true, code: 'RINGING', desc: 'Ringing' });
        // });

        if (!sessionStorage.getItem('sessionData')) {
            logout();
        } else {
            setSessionData(JSON.parse(sessionStorage.getItem('sessionData')));

            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/userStatus`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {}
            };
            axios(options).then(response => {
                if (response.data.eventCode === 'LOGIN' || response.data.eventCode === 'LOGOUT' || response.data.eventCode === 'ACTIVE' || response.data.eventCode === 'LOGGED'){
                    //setUserStatus({ status: 'active', code: response.data.eventCode, desc:response.data.eventDesc });
                    setUserStatus({ "paused":false, code: response.data.eventCode, desc:response.data.eventDesc });
                    if(props.setCurrentUserStatus){
                        props.setCurrentUserStatus(false);
                    }
                }
                else{
                    //setUserStatus({ status: 'paused', code: response.data.eventCode, desc:response.data.eventDesc });
                    setUserStatus({ "paused":true, code: response.data.eventCode, desc:response.data.eventDesc });
                    if(props.setCurrentUserStatus){
                        props.setCurrentUserStatus(true);
                    }
                }
            })
            .catch(function (error) {
                error.contextInfo='al recuperar estado del usuario';
                setError(error);
            });
            
        }


    }, []);


    useEffect(() => {
        const socket = Tools.currentSocketConnection;
        socket.on("forceLogout", data => {
            logout();
            setTimeout(() => alert('Su sesión se encuentra inactiva, se ejecutó un cierre de sesión remoto.'), 2000);
        });

        socket.on("ringing", data => {
            console.log('🟡 DEBUG ringing');
            //setUserStatus({ paused: true, code: 'RINGING', desc: 'Ringing' });
            // changeUserStatus({ paused: false, code: 'RINGING', desc: 'Ringing' }); //changed 07/07/2025
            changeUserStatus({ paused: true, code: 'RINGING', desc: 'Ringing' });
        });
    }, [userStatus]);


    useEffect(() => {
        if (props.externalUserStatus){
            changeUserStatus(props.externalUserStatus);
        }
    }, [props.externalUserStatus]);



    useEffect(() => {
        if (incomingCallStatus && incomingCallStatus === "ended"){
                if(!Tools.locationIsClientRecord(location.pathname)){
                    console.log('🐞DEBUG NO estamos en la ficha, cambiamos a activo');
                    changeUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
                }
            
        }
    }, [incomingCallStatus]);
    

    const switchProfile=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/switchProfile`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            
            if (response.data.newCurrentProfile){
                const newCurrentProfile=response.data.newCurrentProfile;
                currentSessionData.profile_code = newCurrentProfile.code;
                currentSessionData.profile_desc = newCurrentProfile.desc;
                sessionStorage.setItem('sessionData', JSON.stringify(currentSessionData));
                alert(`Su nuevo perfil de usuario es «${newCurrentProfile.desc}». (Este perfil se mantendrá incluso aunque cierre su sesión de usuario)`);
                history.go(0);
            }

            
        }).catch(error => {
            console.log('Error on switchProfile:', error.message);
        })
    }


    const logout = () => {
        Tools.currentSocketConnection.disconnect();
        if (props.softphoneIns){
            props.softphoneInst.disconnect();
        }
        document.documentElement.className = 'theme-light';


        unregister();
        disconnectFromQueuesFromServer();
    }


    const disconnectFromQueuesFromServer=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/forceLogout`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            if (props.setInboundConnectedQueues){
                props.setInboundConnectedQueues([]); //limpia valor presente en APP.js
            }
            sessionStorage.clear();
            history.push('/login');
        });
    }

    const executeUserAMIAction = (action) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/userAMIAction`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: action
        };
        axios(options).then(response => {
            //console.log('🐞DEBUG executeUserAMIAction responseeeeeeeeeee:', response);
        });
    }

    const changeUserStatus =(statusDetails) =>{
        //IF current status is different of new status
        //console.log('%c changeUserStatus-->', 'background: #d06464; color: #ffff', userStatus , statusDetails.code ); 

        if (userStatus && userStatus.code!==statusDetails.code){
            setUserStatus({ paused: statusDetails.paused, code: statusDetails.code, desc: statusDetails.desc  });

            //ami action for every OUTBOUND connected queue
            let connectedCampaigns= JSON.parse(sessionStorage.getItem("connectedCampaigns"));
            if(connectedCampaigns){
                let conectedQueues = [...new Set(connectedCampaigns.map(item => item.context))];
                conectedQueues.forEach(queue => {
                    //console.log('-----> DEBUG AMI ACTION OUT:', { action: 'QUEUEPAUSE', queue: queue, reason: statusDetails.code, paused: statusDetails.paused });
                    //if (statusDetails.code !== 'RINGING' && statusDetails.code !== 'CALLING'){ //excluimos RINGING y CALLING
                    if (statusDetails.code !== 'CALLING'){ //excluimos RINGING y CALLING
                        executeUserAMIAction({ action: 'QUEUEPAUSE', queue: queue, reason: statusDetails.code, paused: statusDetails.paused });
                    }
                });
            }

            //ami action for every INBOUND connected queue
            let connectedInboundQueues = JSON.parse(sessionStorage.getItem("connectedInboundQueues"));
            if (connectedInboundQueues) {
                let conectedQueues = [...new Set(connectedInboundQueues.map(item => item.context))];
                conectedQueues.forEach(queue => {
                    console.log('-----> DEBUG AMI ACTION INB:', { action: 'QUEUEPAUSE', queue: queue, reason: statusDetails.code, paused: statusDetails.paused });
                    //if (statusDetails.code !== 'RINGING' && statusDetails.code !== 'CALLING') {//excluimos RINGING y CALLING
                    if (statusDetails.code !== 'CALLING') {//excluimos RINGING y CALLING
                        executeUserAMIAction({ action: 'QUEUEPAUSE', queue: queue, reason: statusDetails.code, paused: statusDetails.paused });
                    }
                });
            }


            //despues de pausar recien va a registrar LOG de usuario
            //para evitar demoras en llamar a la PAUSA

            Tools.logUserStatus(statusDetails);

            if(props.setCurrentUserStatus){
                props.setCurrentUserStatus(statusDetails.paused);
            }
        }
    }


    const exitPause=()=>{
        let connectedCampaigns=JSON.parse(sessionStorage.getItem("connectedCampaigns"))??[];
        let connectedInboundQueues=JSON.parse(sessionStorage.getItem("connectedInboundQueues"))??[];

        //console.log('🐞DEBUG connectedCampaigns, connectedInboundQueues:', connectedCampaigns, connectedInboundQueues);

        if (sessionData.profile_code === 'EXEC'){//ejecutivos de llamadas
            if(connectedCampaigns.length===0 && connectedInboundQueues.length===0){
                changeUserStatus({ paused: false, code: 'LOGGED', desc:'En sistema'});
            } else{
                changeUserStatus({ paused: false, code: 'ACTIVE', desc:'Disponible'});
            }  
        } else if (sessionData.profile_code === 'EXEC_CHAT' || sessionData.profile_code === 'EXEC_CHAT_REB'){ //exec CHAT
            
            //get sessions list from session storage (updated in Chatroom.js)
            let currentChatSessionsInSE = sessionStorage.getItem('chatSessions');
            if (currentChatSessionsInSE) {
                let currentChatSessions = JSON.parse(currentChatSessionsInSE);
                if (currentChatSessions.length===0){
                    changeUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
                } else { //more than 0
                    changeUserStatus({ paused: false, code: 'CHAT_ATTENDING', desc: 'Atendiento chat' });
                }
            } else {
                changeUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
            }
        }
    }

    return (
        <div className="userMenu" onClick={() =>  !visibleinboundConnections?setVisibilityMenu(!visibilityMenu):null}>  

            {visibleinboundConnections?(
                <InboundConnections closeMethod={()=>{setVisibleInboundConnections(false);}} notifyMethod={props.setInboundConnectedQueues} userStatus={userStatus} changeUserStatus={changeUserStatus}/>
            ):null}
            <div className={visibilityMenu ? 'wrapper active' : 'wrapper'}>    
                <div>
                    <span className="name">
                        {/* [userStatus:{JSON.stringify(userStatus)}] &nbsp; */}
                        {sessionData.name} &nbsp;
                        {userStatus ? (
                            <span className={userStatus.paused ? 'userStatus paused' : userStatus.code === 'LOGGED' ? 'userStatus waiting' : userStatus.code === 'RINGING' ? 'userStatus calling' : 'userStatus active'}>[<i className={'statusIcon ' + userStatus.code}></i>{userStatus.desc}]</span>
                        ) : null}
                    </span>
                    <span className="profile">{sessionData.company_desc}/{sessionData.profile_desc} [{sessionData.extension}]</span>
                </div>
                {sessionData.profile_picture?(
                    <img src={sessionData.profile_picture} alt="" className="profilePicture"/>
                ):(
                    <UserSvgIcon/>
                )}
            </div>
            {visibilityMenu && (
                <ul>
                    {/* <li><a onClick={reconectSoftphone}>Reconectar softphone</a></li> */}
                    {(sessionData.profile_code === 'EXEC' || sessionData.profile_code === 'EXEC_CHAT' || sessionData.profile_code === 'EXEC_CHAT_REB') && userStatus.code!=='LOGGED' ?(
                        <li className='rel'><a onClick={() => setShowPauseMenu(!showPauseMenu)}>Entrar/Salir de pausa</a>
                            <ul className='subMenu'>
                                <li><a onClick={() => { changeUserStatus({ paused: true, code: 'ADM', desc: 'Administrativo' }); }}><i className='status paused'></i><i className='statusIcon ADM' />ADMINISTRATIVO</a></li>
                                <li><a onClick={() => { changeUserStatus({ paused: true, code: 'ALM', desc: 'Almuerzo' }); }}><i className='status paused'></i><i className='statusIcon ALM'/>ALMUERZO</a></li>
                                <li><a onClick={() => { changeUserStatus({ paused: true, code: 'BK', desc: 'Break' }); }}><i className='status paused'></i><i className='statusIcon BK'/>BREAK</a></li>
                                <li><a onClick={() => { changeUserStatus({ paused: true, code: 'BN', desc: 'Baño' }); }}><i className='status paused'></i><i className='statusIcon BN' />BAÑO</a></li>
                                <li><a onClick={() => { changeUserStatus({ paused: true, code: 'CP', desc: 'Capacitación' }); }}><i className='status paused'></i><i className='statusIcon CP' />CAPACITACIÓN</a></li>
                                <li><a onClick={() => { changeUserStatus({ paused: true, code: 'REU', desc: 'Reunión' }); }}><i className='status paused'></i><i className='statusIcon REU' />REUNIÓN</a></li>
                                
                                {userStatus.paused ? (
                                    <li><a onClick={exitPause}><i className='status active'></i><i className='statusIcon PLAY' />SALIR PAUSA</a></li>
                                ):null}
                                
                            </ul>
                        </li>
                    ):null}
                    
                    {sessionData.profile_code !== 'EXEC_CHAT' && sessionData.profile_code !== 'EXEC_CHAT_REB' && sessionData.profile_code !== 'CONS_CHAT' ? (
                        <li><a onClick={()=>setVisibleInboundConnections(true)}>Inbound</a></li>
                    ):null}

                    {sessionData.alternativeProfiles ?(
                        <li><a onClick={() => switchProfile()}>Intercambiar perfil</a></li>
                    ):null}
                    
                    
                    <li><a onClick={()=>history.push('/profile')}>Información perfil</a></li>
                    <li><a onClick={logout}>Cerrar sesión</a></li>
                </ul>
            )}
        </div>
    );
    
}

export default UserMenu;